var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('layout-vertical',{attrs:{"nav-menu-items":_vm.navMenuItems}},[_c('router-view')],1),_c('app-update-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }